import { useAuthStore } from "../store/useAuth";

/**
 * Checks if an error is an authentication/authorization error
 * that should trigger automatic logout
 */
export const isAuthError = (error: any): boolean => {
  const message = error?.message?.toLowerCase() || "";
  const status = error?.status;

  // Check for specific auth-related messages
  const authMessages = [
    "неверный токен",
    "недействительный токен",
    "invalid token",
    "token expired",
    "authentication token is required",
    "необходима авторизация",
  ];

  const hasAuthMessage = authMessages.some((authMsg) =>
    message.includes(authMsg)
  );

  // Check for auth-related status codes
  const isAuthStatus = status === 401 || (status === 400 && hasAuthMessage);

  return hasAuthMessage || isAuthStatus;
};

/**
 * Handles authentication errors by automatically logging out the user
 * Call this function whenever an API error occurs
 */
export const handleAuthError = (error: any): void => {
  if (isAuthError(error)) {
    const logout = useAuthStore.getState().logout;
    logout();

    // Optional: Redirect to login page
    // window.location.href = '/login';
  }
};
